import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../lib/auth-context';
import api from '../lib/api';

export default function AuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refreshUser } = useAuth();

  useEffect(() => {
    const token = params.get('token');
    if (token) {
      localStorage.setItem('ss_token', token);
      // V64.1 — role-aware landing. The JWT carries no medical_category, so read the
      // fresh /me payload: a nutritionist signing in with Google was previously
      // dumped on the learner dashboard.
      api.get('/api/auth/me').then(({ data }) => {
        refreshUser();
        const role = data?.role;
        if (role === 'superadmin' || role === 'admin') navigate('/admin/dashboard');
        else if (role === 'instructor') navigate('/instructor/dashboard');
        else if (role === 'doctor') navigate(data?.medical_category === 'nutritionist' ? '/doctor/medical-inbox' : '/doctor/dashboard');
        else navigate('/learner/dashboard');
      }).catch(() => navigate('/login?error=session_failed'));
    } else {
      navigate('/login?error=no_token');
    }
  }, [params, navigate, refreshUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="animate-spin h-8 w-8 border-2 border-primary border-t-transparent rounded-full" />
    </div>
  );
}
